module.exports = __webpack_public_path__ + "img/up.ba118274.svg";